import configuration from "./../config.json";
import AccountService from "./../shared/services/accountService";
import CookieService from "./../shared/services/cookiesService";
import { handleClearStoreSingIn } from "./signInActions";

const REQUEST_LOGIN = "REQUEST_LOGIN";
const RESPONSE_LOGIN = "RESPONSE_LOGIN";
const REQUEST_LOGIN_FAILURE = "REQUEST_LOGIN_FAILURE";

const RESPONSE_LOGOUT = "RESPONSE_LOGOUT";
const REQUEST_LOGOUT_FAILURE = "REQUEST_LOGOUT_FAILURE";

const SET_LOGIN = "SET_LOGIN";
const SET_LOGOUT = "SET_LOGOUT";

const CLEAR_AUTH_ERRORS = "CLEAR_AUTH_ERRORS";

const requestLogInAction = () => {
  return {
    type: REQUEST_LOGIN,
  };
};

const responseLogInAction = (data) => {
  return {
    type: RESPONSE_LOGIN,
    data,
  };
};

const requestLogInfailureAction = (errors) => {
  return {
    type: REQUEST_LOGIN_FAILURE,
    errors,
  };
};

const logIn = (data) => {
  return (dispatch) => {
    dispatch(requestLogInAction());

    AccountService.logIn(data)
      .then((result) => {
        CookieService.setCookie(
          configuration.cookieName,
          JSON.stringify({
            token: result.data.token,
            domain: result.data.domain,
            email: result.data.email,
            companyTitle: result.data.companyTitle,
            isNotPayment: result.data.isNotPayment,
            isWinter: result.data.isWinter,
            companyId: result.data.companyId,
            userTitle: result.data.userTitle,
            permissions: result.data.permissions,
          })
        );
        CookieService.updateExpires(configuration.cookieName, 12);

        dispatch(responseLogInAction(result.data));
        dispatch(handleClearStoreSingIn());
      })
      .catch((error) => {
        dispatch(requestLogInfailureAction(error.response));
      });
  };
};

const logInDemo = () => {
  return (dispatch) => {
    dispatch(requestLogInAction());

    AccountService.logInDemo()
      .then((result) => {
        CookieService.setCookie(
          configuration.cookieName,
          JSON.stringify({
            token: result.data.token,
            domain: result.data.domain,
            email: result.data.email,
            companyTitle: result.data.companyTitle,
            isWinter: result.data.isWinter,
            companyId: result.data.companyId,
            userTitle: result.data.userTitle,
            permissions: result.data.permissions,
          })
        );
        CookieService.updateExpires(configuration.cookieName, 12);

        dispatch(responseLogInAction(result.data));
        dispatch(handleClearStoreSingIn());
      })
      .catch((error) => {
        dispatch(requestLogInfailureAction(error.response));
      });
  };
};

const responseLogOutAction = () => {
  return {
    type: RESPONSE_LOGOUT,
  };
};

const requestLogOutfailureAction = (errors) => {
  return {
    type: REQUEST_LOGOUT_FAILURE,
    errors,
  };
};

const logOut = () => {
  return (dispatch) => {
    dispatch(responseLogOutAction());
    CookieService.deleteCookie(configuration.cookieName);
  };
};

const setLoginAction = (data) => {
  return {
    type: SET_LOGIN,
    data,
  };
};

const setLogin = (options) => {
  return (dispatch) => {
    dispatch(setLoginAction(options));
  };
};

const setLogoutAction = () => {
  return {
    type: SET_LOGOUT,
  };
};

const setLogout = () => {
  return (dispatch) => {
    CookieService.deleteCookie(configuration.cookieName);
    dispatch(setLogoutAction());
  };
};

const clearAuthErrors = () => {
  return {
    type: CLEAR_AUTH_ERRORS,
  };
};

const REQUEST_OAUTH2_PARAMS = "REQUEST_OAUTH2_PARAMS";
const RESPONSE_OAUTH2_PARAMS = "RESPONSE_OAUTH2_PARAMS";
const REQUEST_OAUTH2_PARAMS_FAILURE = "REQUEST_OAUTH2_PARAMS_FAILURE";

const requestGetOAuth2PramsAction = () => {
  return {
    type: REQUEST_OAUTH2_PARAMS,
  };
};

const responseGetOAuth2PramsAction = (data) => {
  return {
    type: RESPONSE_OAUTH2_PARAMS,
    data,
  };
};

const requestGetOAuth2PramsFailureAction = (errors) => {
  return {
    type: REQUEST_OAUTH2_PARAMS_FAILURE,
    errors,
  };
};

const getOAuth2Prams = (data) => {
  return (dispatch) => {
    dispatch(requestGetOAuth2PramsAction());

    AccountService.getOAuth2Parametrs()
      .then((result) => {
        const { oAuthHost, method, parametrs } = result.data;

        let url = `${oAuthHost}/${method}`;

        Object.keys(parametrs).forEach((key, index) => {
          const prefix = index === 0 ? "?" : "&";
          url += `${prefix}${key}=${parametrs[key]}`;
        });
        
        window.location.assign(url);

        dispatch(responseGetOAuth2PramsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestGetOAuth2PramsFailureAction(error.response));
      });
  };
};

const logInOAuth2 = (data) => {
  return (dispatch) => {
    dispatch(requestLogInAction());

    AccountService.logInOAuth2(data)
      .then((result) => {
        window.location.assign(window.location.host);
        CookieService.setCookie(
          configuration.cookieName,
          JSON.stringify({
            token: result.data.token,
            domain: result.data.domain,
            email: result.data.email,
            companyTitle: result.data.companyTitle,
            isNotPayment: result.data.isNotPayment,
            isWinter: result.data.isWinter,
            companyId: result.data.companyId,
            userTitle: result.data.userTitle,
            permissions: result.data.permissions,
          })
        );
        CookieService.updateExpires(configuration.cookieName, 12);

        dispatch(responseLogInAction(result.data));
        dispatch(handleClearStoreSingIn());

        window.location.assign(window.location.origin);
      })
      .catch((error) => {
        dispatch(requestLogInfailureAction(error.response));
      });
  };
};

export {
  logIn,
  logInDemo,
  requestLogInAction,
  responseLogInAction,
  requestLogInfailureAction,
  REQUEST_LOGIN,
  RESPONSE_LOGIN,
  REQUEST_LOGIN_FAILURE,
  logOut,
  responseLogOutAction,
  requestLogOutfailureAction,
  RESPONSE_LOGOUT,
  REQUEST_LOGOUT_FAILURE,
  setLoginAction,
  setLogin,
  SET_LOGIN,
  setLogout,
  setLogoutAction,
  SET_LOGOUT,
  clearAuthErrors,
  CLEAR_AUTH_ERRORS,
  getOAuth2Prams,
  logInOAuth2,
};
